import React, { useEffect, useState, useContext } from 'react';
import css from './ChooseProduct.module.scss';
import { Portal, svgSprite, FieldError } from '../../../../hybrid/wrappers';
import T from '../../../../common/components/T';
import { transformProfuctGrid } from './initData';
import { getData } from '../../../../common/utils/router';
import GridComponent from '../../../../widgets/grid/GridComponent/GridComponent';
import UserContext from '../../../../common/utils/getContext';
// import { generateCompStylers } from '../../../../common/utils/styles';

const ChooseProduct = (props) => {
    const { userToken, lang, setAlertData } = useContext(UserContext);
    const [productModal, setProductModal] = useState(false);
    const [gridData, setGridData] = useState(false);
    const { url, title, setFormData, attribute, deletedId, setDeletedId, value, fieldsErr, compStyle = {}, disabled } = props;
    // const { stylers, classes } = generateCompStylers(compStyle);
    const [selectProducts, setSelectProducts] = useState([]);

    useEffect(() => {
        if (value?.length) {
            setSelectProducts(value);
        }
    }, [value]);

    useEffect(() => {
        (async () => {
            const dataProducts = await getData(url, userToken, lang);

            if (dataProducts?.data) {
                const data = transformProfuctGrid(dataProducts);
                setGridData(data);
            }
        })();
    }, [userToken, lang]);

    useEffect(() => {
        setFormData(attribute, selectProducts);
    }, [selectProducts]);

    useEffect(() => {
        if (deletedId) {
            setSelectProducts((pre) => {
                return [...pre.filter((i) => i.id != deletedId)];
            });
        }
    }, [deletedId]);

    return (
        <div className={css.adminProductsWrapper}>
            <div className={css.adminProductsTopWrapper}>
                <div className={css.adminProductsBtns}>
                    <div
                        className={css.selectProductAddProduct}
                        style={disabled ? { cursor: 'not-allowed' } : {}}
                        onClick={() => (!disabled ? setProductModal((pre) => !pre) : null)}
                    >
                        {title?.body}
                    </div>
                </div>
            </div>

            {fieldsErr?.items && fieldsErr.items.length
                ? fieldsErr.items.map((err, idx) => (
                      <FieldError compStyle={compStyle?.error} key={`${attribute}${idx}`}>
                          {err}
                      </FieldError>
                  ))
                : null}
            {productModal && (
                <div>
                    <Portal closeHandler={() => setProductModal(false)}>
                        <div className={css.modalWrapper}>
                            <div className={css.modalClose} onClick={() => setProductModal(false)}>
                                {svgSprite('cross', { className: css.modalCloseIcon })}
                            </div>
                            <div className={css.modalTitleWrap}>
                                <p className={css.modalTitle}>
                                    <T textName='adminUser-selectProductModal-Title11' defaultStr='Выбрать продукт' page='all' />
                                </p>
                            </div>
                            <div>
                                {gridData ? (
                                    <GridComponent
                                        viewThead={gridData.thead}
                                        viewData={gridData}
                                        setGridData={setGridData}
                                        convertData={transformProfuctGrid}
                                        handlers={{
                                            tr: {
                                                onClick: (rowData) => {
                                                    if (
                                                        selectProducts.some(
                                                            (obj) => (obj?.product?.id || obj.id) === rowData?.product?.id
                                                        )
                                                    ) {
                                                        setAlertData({
                                                            type: 'error',
                                                            cont: (
                                                                <T
                                                                    textName='adminUser-selectProductModal-add-product_exist'
                                                                    defaultStr='Продукт уже добавлен'
                                                                    page='all'
                                                                />
                                                            )
                                                        });
                                                    } else {
                                                        setSelectProducts((pre) => [...pre, rowData?.product]);
                                                        setDeletedId();
                                                        setAlertData({
                                                            type: 'success',
                                                            cont: (
                                                                <T
                                                                    textName='adminUser-selectProductModal-add-product'
                                                                    defaultStr='Продукт добавлен'
                                                                    page='all'
                                                                />
                                                            )
                                                        });
                                                    }
                                                }
                                            }
                                        }}
                                        sticky={true}
                                        gridStyles={{
                                            gridWrapper: {
                                                className: css.gridWrapper
                                            }
                                        }}
                                    />
                                ) : null}
                            </div>
                        </div>
                    </Portal>
                </div>
            )}
        </div>
    );
};

export default ChooseProduct;
